module.exports = __webpack_public_path__ + "img/australia-pneumonia-male.94c650e3.png";